var jcsfApp;
(function (jcsfApp) {
    var app;
    (function (app) {
        var memberAdd;
        (function (memberAdd) {
            var AddUserController = (function () {
                function AddUserController($location, constantService, dataService, $scope) {
                    this.$location = $location;
                    this.constantService = constantService;
                    this.dataService = dataService;
									this.savedSuccessfully = false;
									this.$scope = $scope; 
									this.message = "";

									class Registration {
										constructor(first, last, username, email) {
											this.FirstName = first;
											this.LastName = last;
											this.UserName = username;
											this.Email = email;
											this.Password = "123Password321";
										}
										isValid() {
											return Boolean(this.UserName && this.Email && this.LastName); 
										}
									}
									this.registration = new Registration("", "", "", "");
                }
                AddUserController.prototype.signUp = function () {
                    var $this = this;
                    this.dataService.add(this.constantService.apiProfileURI + 'signup', this.registration).then(function (response) {
                        if (response.Value && response.Value.message && response.Value.message.length && response.Value.message.startsWith('ERROR')) {
                            $this.savedSuccessfully = false;
                            $this.message = response.Value.message;
                            return;
                        }
                        else {
                            $this.user = response;
                            $this.savedSuccessfully = true;
													  $this.message = "<a href='/#/Member/" + $this.user.UserId + ">Click to Continue</a>";
													  this.$scope.$state.go('members');
                        }
                    }, function (response) {
                        var errors = [];
                        for (var key in response.data.modelState) {
                            if (response.data.modelState.hasOwnProperty(key)) {
                                for (var i = 0; i < response.data.modelState[key].length; i++) {
                                    errors.push(response.data.modelState[key][i]);
                                }
                            }
                        }
                        $this.message = "Failed to register user due to:" + errors.join(' ');
                    });
                };
                AddUserController.$inject = ['$location', "constantService", "dataService", 'authService', '$scope'];
                return AddUserController;
            })();
            angular.module("jcsfApp")
                .controller("AddUserController", AddUserController);
        })(memberAdd = app.memberAdd || (app.memberAdd = {}));
    })(app = jcsfApp.app || (jcsfApp.app = {}));
})(jcsfApp || (jcsfApp = {}));
